'use client'

import { Dialog } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isOpen: boolean
  onSubmit: () => void
  onClose: () => void
}

const ModerateFeedbackModal = ({ isOpen, onClose, onSubmit }: Props) => {
  const translate = useTranslate('user.feedback.moderate_modal')

  return (
    <Dialog
      show={isOpen}
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('action_moderate'),
          style: Dialog.ActionStyling.Filled,
          theme: 'warning',
          testId: 'feedback-moderate-action-confirm',
          callback: onSubmit,
        },
        {
          text: translate('action_close'),
          testId: 'feedback-moderate-action-cancel',
          callback: onClose,
        },
      ]}
    />
  )
}

export default ModerateFeedbackModal
